import React from 'react';

export default function Title(props) {
  return <h3 className="titlePro">{props.name}</h3>;
}
